document.addEventListener("DOMContentLoaded", function() {
    // Make all external links open in new tab
    const allLinks = document.querySelectorAll("a");
  
    allLinks.forEach((link) => {
        try {
            const url = new URL(link.href, window.location.origin);
            const isExternal = url.hostname !== window.location.hostname;
            if (isExternal) {
                link.setAttribute("target", "_blank")
            }
        } catch (e) {
            console.log("Invalid URL:", link.href);
        }
    });
  });
  